import { baseApi } from '@/app/baseApi';
import { sessionEstablished, sessionExpired } from './authSlice';
import type { SessionResponse } from './types';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<SessionResponse, { email: string; password: string }>({
      query: (credentials) => ({ url: '/auth/login', method: 'POST', body: credentials }),
      invalidatesTags: ['Session'],
      onQueryStarted: async (_arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(sessionEstablished(data));
        } catch {
          // The form surfaces the error; nothing to update here.
        }
      },
    }),

    currentSession: builder.query<SessionResponse, void>({
      query: () => '/auth/me',
      providesTags: ['Session'],
      onQueryStarted: async (_arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(sessionEstablished(data));
        } catch {
          dispatch(sessionExpired());
        }
      },
    }),

    logout: builder.mutation<void, void>({
      query: () => ({ url: '/auth/logout', method: 'POST' }),
      onQueryStarted: async (_arg, { dispatch, queryFulfilled }) => {
        await queryFulfilled.catch(() => undefined);
        dispatch(sessionExpired());
        // Drop every cached response so the next user starts clean.
        dispatch(baseApi.util.resetApiState());
      },
    }),

    changePassword: builder.mutation<void, { currentPassword: string; newPassword: string }>({
      query: (body) => ({ url: '/auth/change-password', method: 'POST', body }),
      invalidatesTags: ['Session'],
    }),
  }),
});

export const {
  useLoginMutation,
  useCurrentSessionQuery,
  useLogoutMutation,
  useChangePasswordMutation,
} = authApi;
